// update state
const setActionTaskContextExpColaps = (payload) => {
    return {
        type: "ACTIONRIGHTSIDEBAR",
        payload
    }
}

export default setActionTaskContextExpColaps;


// WEBPACK FOOTER //
// ./src/actions/setActionTaskContextExpColaps.js